// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"939c3e95","933":"30d64a95"}[chunkId] + ".chunk.css";
};